import React from 'react';
import { Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import BlockTabs from '../../../BlockTabs';
import PieChart from '../../../charts/PieChart'
import { Loader } from '../../../components';
import { useGetPublisherAdminOsVersionPerOsQuery } from '../../../../api/publisherAdminApiSlice';
import versionCompare from '../../../../services/versionCompare';

const DevicePerOsVersion = ({publisherId, ...props}) => {
  const { t } = useTranslation();
  const { data = [], isSuccess, isError, refetch } = useGetPublisherAdminOsVersionPerOsQuery(publisherId)
  const loaderProps = { success: isSuccess, error: isError, retry: refetch }
  const iosPieData = data
                      .filter((x)=>(x.os === "ios"))
                      .sort((a,b) => versionCompare(b.major_os_version,a.major_os_version) )
                      .map((x)=>({"name":x.major_os_version,"y":x.active_devices}))
  const androidPieData = data
                      .filter((x)=>(x.os === "android"))
                      .sort((a,b) => versionCompare(b.major_os_version,a.major_os_version) )
                      .map((x)=>({"name":x.major_os_version,"y":x.active_devices}))

  return (
    <BlockTabs title={t('version.device_per_os_version')} defaultActiveKey="android" {...props}>
      <Loader {...loaderProps} minHeight={"100%"} key="ios" title="ios">
        <PieChart data={iosPieData}  legendOptions={{show: false}} datalabels/>
      </Loader>
      <Loader {...loaderProps} minHeight={"100%"} key="android" title="android">
        <PieChart data={androidPieData}  legendOptions={{show: false}} datalabels/>
      </Loader>
    </BlockTabs>
  )
}

export default DevicePerOsVersion
